import {Component, OnInit} from '@angular/core';
import {BasePageComponent} from "../../base-page.component";
import { RegistryService } from 'src/app/services/domain/registry.service';
import { saveAs } from 'file-saver';
import {AnagraficaDto} from "../../models/anagrafica.models";
import {ComuniDto, NazioniDto} from "../../models/comuni.models";
import {UtilsService} from "../../services/utils.service";

//lasciare SignInRequest o crearne uno nuovo?

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css'],
  providers : [RegistryService]
})
export class SettingsComponent extends BasePageComponent  implements OnInit {

  public registryDto : AnagraficaDto = new AnagraficaDto();
  constructor(private registryService : RegistryService) {
    super();
  }

  ngOnInit(): void {
    this.getRegistryDetail();
  }

  public getProfileExport(){
    this.showSpinner();
    this.registryService.getProfileExport().subscribe(response => {
      const blob = new Blob([response], {type: response.type});
      saveAs(blob, "DatiPersonali.xlsx");
      this.hideSpinner();
    });
  }

  public getRegistryDetail(){
    this.asyncCall(() => this.registryService.getRegistryDetail(), response => {
      this.registryDto = response.Item || new AnagraficaDto();
      this.setDatesObjects();
    });
  }

  public registryUpdate(){
    this.asyncCall(() => this.registryService.registryUpdate(this.registryDto), response => {
      if (response.IsSuccess)
        this.showMessageSaveCompleted();
      else {
        var errorMsg = response.ErrorMessage;
        this.showError("Errore nel salvataggio dei dati: inserire tutti i campi obbligatori.");
      }
    });
  }

  private setDatesObjects(): void {
    if (this.registryDto.DataNascita != null)
      this.registryDto.DataNascita = UtilsService.ConvertTo_DATE_DATABASE_FORMAT(this.registryDto.DataNascitaSTR);

    if (this.registryDto.DateIns != null) {
      this.registryDto.DateIns = UtilsService.ConvertTo_DATE_DATABASE_FORMAT(this.registryDto.DateInsStr);
    }
  }
}
